<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/personalTraining')" class="btn-grey"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister" v-if="editData">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="pt_name" v-model="editData.name" name="name" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Nickname</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="pt_nickname" v-model="editData.nickname" name="nickname" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Email</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.email" name="email" v-validate="'required'" type="text"></b-form-input>
                  <span class="error">{{ errors.first('email') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_pt">Image</label>
                </b-col>
                <b-col sm="10">
                  <b-form-file name="file" v-validate="'required'" @change="previewImage" accept="image/*" v-model="imgUpload" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
                  <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                  <div class="image-preview" v-if="imageData.length > 0">
                      <img class="preview" :src="imageData">
                  </div>
                  <span class="error">{{ errors.first('file') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="short_description">Specialist</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="short_description" name="specialist" v-validate="'required'" v-model="editData.short_description" type="text"></b-form-input>
                  <span class="error">{{ errors.first('specialist') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="description">Description</label>
                </b-col>
                <b-col sm="10">
                  <textarea id="description" name="description" class="w-100" rows="3" v-model="editData.description"></textarea>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="editData.branch_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>PT Tier</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select
                      name="pt_tier"
                      v-validate="'required'"
                      v-model="editData.pt_tier"
                      :options="optTier"
                      class="mb-3"
                    />
                  </div>
                  <span class="error">{{ errors.first("pt_tier") }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>RFID Card Code</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.rfid_card_code" name="rfid_card_code" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Status</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="editData.status" :options="options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <!-- Show to report -->
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Show to Report</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="pt_tier" v-model="editData.is_show_to_report">
                    <option :value="null">Please select</option>
                    <option :value="0">No</option>
                    <option :value="1">Yes</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Resign Date</label>
                </b-col>
                <b-col sm="3">
                  <flat-pickr :config="config" v-model="editData.resign_date" name="resign_date" class="w-100 border-bottom"></flat-pickr>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Is Parttime</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="editData.is_parttimer" :options="is_parttimer_options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Is Supervisor</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="editData.is_supervisor" :options="is_parttimer_options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Is GF Partime</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="status" v-validate="'required'" v-model="editData.is_gf_partimer" :options="is_parttimer_options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Is Manager PT</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select name="is_manager_pt" v-validate="'required'" v-model="editData.is_manager_pt" :options="is_parttimer_options" class="mb-3" />
                  </div>
                  <span class="error">{{ errors.first('is_manager_pt') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="address">Show on Mobile</label>
                </b-col>
                <b-col sm="10">
                  <toggle-button v-model="is_show_on_mobile" name="is_show_on_mobile" :sync="true"/>
                  <span class="error">{{ errors.first('is_show_on_mobile') }}</span>
                </b-col>
              </b-row>
              <hr class="mb-3">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Instagram</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="editData.instagram" name="instagram" type="text"></b-form-input>
                  <span style="font-size: 12px;color: grey;font-style: italic;">*instagram username example <b>@jehanislianur</b></span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_blog">Purpose</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor class="editor-custom" name="purpose" ref="myTextEditor" v-model="editData.purpose_text" :options="editorOption"></quill-editor>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_blog">Speciality</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor class="editor-custom" name="speciality" ref="myTextEditor" v-model="editData.speciality_text" :options="editorOption"></quill-editor>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_blog">Certification</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor class="editor-custom" name="certification" ref="myTextEditor" v-model="editData.certification_text" :options="editorOption"></quill-editor>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>PT Tier</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select
                      name="mobile_pt_tier"
                      v-validate="'required'"
                      v-model="editData.mobile_pt_tier_id"
                      :options="mobilePTTier"
                      class="mb-3"
                    />
                  </div>
                  <span class="error">{{ errors.first("mobile_pt_tier") }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'editCoach',
  data: function () {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote'],
            [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ]
        }
      },
      dataBranch: [],
      editData: false,
      imageData: '',
      imgUpload: '',
      file: null,
      is_show_on_mobile: false,
      speciality_text: '',
      certification_text: '',
      purpose_text: '',
      options: [
        { value: null, text: 'Please select' },
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' }
      ],
      is_parttimer_options: [
        { value: 0, text: 'No' },
        { value: 1, text: 'Yes' }
      ],
      config: {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Y-m-d'
      },
      optTier: [],
      mobilePTTier: []
    }
  },
  components: {
    quillEditor
  },
  methods: {
    validateRegister () {
      this.$validator.validateAll().then((result) => {
        if(result) {
          this.editData.is_show_on_mobile = this.is_show_on_mobile ? 1 : 0
          if (`${this.editData.resign_date}`.includes('0000-00-00') || this.editData.resign_date == null) {
            delete this.editData.resign_date
          }
          let data1 = this.editData
          let data2 = Object.assign({}, data1)
          delete data2.branch
          delete data2.password
          delete data2.id
          delete data2.personal_training_en
          this.editData = data2
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
          var data = new FormData()
          Object.keys(this.editData).forEach(keyName => {
            data.append(keyName, this.editData[keyName])
          });
          data.append('photos', this.imgUpload)
          axios.put('fitness/v1/personal_training/'+(this.$route.query.id), data).then(response => {
            //console.log('test', response)
            this.$toast.success('data saved successfully!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          this.$router.push('/personalTraining')
          }).catch(error => {
            console.log('error', error)
            this.$toast.success('cant saved data!', 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/pt_tier?page=&limit=').then(response => {
        // this.items = response.data.data.rows
        // this.totalPage = response.data.meta.pageCount
        this.optTier = []
        this.optTier.push({ value: null, text: "Please select" })
        for (let i = 0; i < response.data.data.rows.length; i++) {
          const el = response.data.data.rows[i];
          this.optTier.push({ value: `${el.id}`, text: `${el.name}` })
        }
        console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })

      // mobile view
      axios.get('fitness/v1/pt_tier/mobile_view?page=&limit=').then(response => {
        // this.items = response.data.data.rows
        // this.totalPage = response.data.meta.pageCount
        this.mobilePTTier = []
        this.mobilePTTier.push({ value: null, text: "Please select" })
        for (let i = 0; i < response.data.data.rows.length; i++) {
          const el = response.data.data.rows[i];
          this.mobilePTTier.push({ value: `${el.id}`, text: `${el.name}` })
        }
      }).catch(error => {
        console.log('error', error)
      })

      // axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/personal_training/'+(this.$route.query.id)).then(response => {
        this.editData = response.data.data
        this.imgUpload = response.data.data.thumbnail
        this.is_show_on_mobile = response.data.data.is_show_on_mobile == 1 ? true : false
        // console.log('test', response)
        this.imageData = Auth.apiUrl + 'fitness/v1/img/personal_training/' + response.data.data.thumbnail
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('fitness/v1/branch/').then(response => {
        this.dataBranch = response.data.data.rows
        // console.log('test', response)
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
